<template>
    <div class="baseSettingEdit">
      <div class="titleForm-container">{{edit?"编辑基地":"查看基地"}}</div>
      <div :class="{'content-form-container':true,'readonly':!edit}">
        <div class="main-container-form">
          <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="ruleForm">
            <el-form-item label="基地名称" prop="name">
              <el-input v-model="baseForm.name" size="medium"  style="width:100%;" placeholder="请输入基地名称" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20"></el-input>
            </el-form-item>
            <el-form-item label="基地负责人" prop="leader">
              <el-select v-model="baseForm.leader" placeholder="请选择负责人" size="medium" style="width:100%;" @change="getPhone"  >
                <el-option v-for="item in companyUser" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model.number="baseForm.phone" disabled :maxlength="num11" placeholder="请输入联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" size="medium" style="width:100%;"></el-input>
            </el-form-item>
            <el-row :gutter="5">
              <el-form-item label="基地地址" required>
                <el-col :span="8">
                  <el-form-item prop="provinceNo">
                    <el-select v-model="baseForm.provinceNo" placeholder="请选择省份" size="medium" style="width:100%;" @change="selectProvince" >
                      <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="cityNo" v-if="citys.length>0">
                    <el-select v-model="baseForm.cityNo" placeholder="请选择市" size="medium" style="width:100%;" @change="selectCity" >
                      <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="countyNo" v-if="countys.length>0">
                    <el-select v-model="baseForm.countyNo" placeholder="请选择县" size="medium" style="width:100%;" >
                      <el-option v-for="item in countys" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
            <el-form-item prop="detail">
              <el-input v-model="baseForm.detail"  size="medium" style="width:100%;" type="text" :maxlength="num30" placeholder="请输入详细地址" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-col :span="8">
                <el-button class="edit-save-btn" @click="saveEditBaseSetting('baseForm')">保存</el-button>
              </el-col>
              <el-col :span="8" >
                <el-button class="cancel-btn" @click="cancelForm('ruleForm')">取消</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
export default {
  name: "baseSettingEdit",
  data() {
    return {
      edit: false,
      id: this.$route.query.id,
      num20: 20,
      num11: 11,
      num30: 30,
      companyUser: [],
      citys: [],
      countys: [],
      baseForm: {
        name: "",
        leader: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        detail: "" // 详细地址
      },
      rules: {
        name: [
          {
            required: true,
            message: "请先输入基地名称"
          },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            message: "基地名称格式不对,请重新输入"
          }
        ],
        leader: [
          { required: true, message: "请先选择负责人", trigger: "change" }
        ],
        phone: [
          { required: true, message: "请先填写联系电话", trigger: "blur" },
          {
            pattern: /^1[3|4|5|7|8|9][0-9]\d{4,8}$/,
            message: "联系电话格式不对,请重新输入"
          }
        ],
        provinceNo: [
          { required: true, message: "请先选择省份", trigger: "change" }
        ],
        cityNo: [{ required: true, message: "请先选择市", trigger: "change" }],
        countyNo: [
          { required: true, message: "请先选择县", trigger: "change" }
        ],
        detail: [
          { required: true, message: "请先输入详细地址" }
          // {
          //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
          //   message: "详细地址格式不对,请重新输入",
          //   min: 2
          // }
        ]
      }
    };
  },
  methods: {
    ...mapActions(modules.base, ["changeBaseSetting", "getChangeBaseSetting"]),
    ...mapActions(modules.user, ["getCompanyUser"]), //基地负责人
    ...mapActions(modules.area, ["getProvinces", "getArea"]),
    //获取联系方式
    async getPhone(e) {
      this.baseForm.phone = Number(this.companyUser.find(f => f.id == e).phone);
    },
    //省份获取之后 获取对应的城市
    async selectProvince() {
      let obj = {
        parentNo: this.baseForm.provinceNo
      };
      let result = await this.getArea(obj);
      this.citys = result;
      this.baseForm.cityNo = null;
      this.baseForm.countyNo = null;
      this.countys = [];
    },
    // 城市获取之后 获取对应的县市
    async selectCity() {
      let obj = {
        parentNo: this.baseForm.cityNo
      };
      let result = await this.getArea(obj);
      this.countys = result;
      this.baseForm.countyNo = null;
    },
    //编辑---获取当前行数据
    async getBaseSettingData() {
      let result = await this.getChangeBaseSetting(this.id);
      this.baseForm.name = result.name;
      this.baseForm.leader = result.leaderId;
      this.baseForm.detail = result.address;
      this.baseForm.phone = result.phone;
      this.baseForm.provinceNo = result.provinceId;
      await this.selectProvince();
      this.baseForm.cityNo = result.cityId;
      await this.selectCity();
      this.baseForm.countyNo = result.countyId;
    },
    // 保存编辑设置
    saveEditBaseSetting(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.id,
            name: this.baseForm.name,
            leaderId: this.baseForm.leader,
            areaId:
              this.baseForm.countyNo ||
              this.baseForm.cityNo ||
              this.baseForm.provinceNo,
            detail: this.baseForm.detail
          };
          this.changeBaseSetting(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.baseForm = {
                  name: "",
                  leader: "", // 联系人
                  phone: "",
                  provinceNo: "", // 省份
                  cityNo: "", // 城市
                  countyNo: "", // 辖区
                  detail: "" // 详细地址
                };
                history.go(-1);
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      // 取消返回
      history.go(-1);
    }
  },
  async mounted() {
    this.edit = await checkPermission.initPagePermission(this.$route, { permissionId: 500 });
    document.title = this.edit ? "编辑基地设置" : "查看基地设置";
    await this.getProvinces();
    this.getBaseSettingData();
    let result = await this.getCompanyUser(1); //获取负责人
    this.companyUser = result;
  },
  computed: {
    ...mapState(modules.area, ["provinces"])
  }
};
</script>

<style >
</style>
